export default (state) => state.customer.name
